const langInvestDashboardMultiExpertises = {
	called_capital: {
		tag: 'invest.dashboard_multi_expertises.called_capital',
		fr: 'Capital appelé',
		en: 'Called capital',
	},
	callable_capital: {
		tag: 'invest.dashboard_multi_expertises.callable_capital',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},
	nb_funds: {
		tag: 'invest.dashboard_multi_expertises.nb_funds',
		fr: 'Nombre de fonds',
		en: 'Number of funds',
	},
	encours: {
		tag: 'invest.dashboard_multi_expertises.encours',
		fr: 'Encours',
		en: 'Outstanding',
	},
	committed_capital: {
		tag: 'invest.dashboard_multi_expertises.committed_capital',
		fr: 'Montant engagé',
		en: 'Committed amount',
	},
	gross_net_irr: {
		tag: 'invest.dashboard_multi_expertises.gross_net_irr',
		fr: 'TRI net global',
		en: 'Gross net IRR',
	},
	global_multiple: {
		tag: 'invest.dashboard_multi_expertises.global_multiple',
		fr: 'Multiple global',
		en: 'Global multiple',
	},
	graph_title_your_investment_in: {
		tag: 'invest.dashboard_multi_expertises.graph_title_your_investment_in',
		fr: 'Vos investissements en',
		en: 'Your investments in',
	},
	graph_tooltip: {
		tag: 'invest.dashboard_multi_expertises.graph_tooltip',
		fr: 'Vos investissements représentent la somme de vos encours dans nos fonds liquides et de vos capitaux engagés dans nos fonds alternatifs',
		en: 'Your investments represent the sum of your holdings in our liquid funds and your capital commitments in our alternative funds',
	},
	graph_legend_dry_powder: {
		tag: 'invest.dashboard_multi_expertises.graph_legend_dry_powder',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},
	graph_legend_outstanding: {
		tag: 'invest.dashboard_multi_expertises.graph_legend_outstanding',
		fr: 'Encours',
		en: 'Outstanding',
	},
	graph_legend_net_called_capital: {
		tag: 'investment.dashboard_multi_expertises.graph_legend_net_called_capital',
		fr: 'Capital net',
		en: 'Capital at work',
	},
};

export default langInvestDashboardMultiExpertises;
